function resolveLocalApiBaseUrl() {
  if (typeof window === "undefined") {
    return "http://localhost:4000/api/v1";
  }

  const hostname = window.location.hostname === "127.0.0.1" ? "127.0.0.1" : "localhost";
  return `http://${hostname}:4000/api/v1`;
}

const LOCAL_API_BASE_URL = resolveLocalApiBaseUrl();

const configuredApiBaseUrl = import.meta.env.VITE_API_URL?.trim();

export const API_BASE_URL =
  configuredApiBaseUrl && configuredApiBaseUrl.length > 0
    ? configuredApiBaseUrl.replace(/\/+$/, "")
    : import.meta.env.DEV
      ? LOCAL_API_BASE_URL
      : "";

export const REALTIME_BASE_URL = API_BASE_URL ? new URL(API_BASE_URL).origin : "";

export function buildApiUrl(path: string) {
  if (!API_BASE_URL) {
    throw new Error(
      "Le frontend n'est pas encore connecte au backend en production. Configure VITE_API_URL avec https://api.ascsonatel.com/api/v1."
    );
  }

  return `${API_BASE_URL}${path}`;
}//
